import { ReadonlyRefObject, useLayoutEffect } from "react";

export function useScrollToTop<TElement extends HTMLElement>(
	ref: ReadonlyRefObject<TElement | null>,
	deps: React.DependencyList
): void {
	useLayoutEffect(
		() => {
			const element: TElement | null = ref.current;
			if (!element) {
				return;
			}
			element.scrollTop = 0;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[ref, ...deps]
	);
}
